
export class WorkOrder {
    public id: string;
    public code: string;
    public thingId: string;
    public status: WorkOrderStatus;
    public serviceId: string;
    public transportDocumentCode: string;
    public creationTimestamp: number;
    public approvalTimestamp: number;
    public startTimestamp: number;
    public endTimestamp: number;
    public discardTimestamp: number;
    public totalWorkTime: number;
    public remainingWorkTime: number;
    public actionCount: number;
    public sparePartCount: number;
    public notes: string;
    public machineWorkingHours: number;
}

export enum WorkOrderStatus {
    DRAFT = 'DRAFT',
    APPROVED = 'APPROVED',
    EXECUTION = 'EXECUTION',
    COMPLETED = 'COMPLETED',
    DISCARDED = 'DISCARDED'
}